import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function MyPreferences() {
  const { user, refreshUser } = useAuth();
  const [maxM, setMaxM] = useState("");
  const [pref, setPref] = useState("none");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) {
      setMaxM(user.max_shifts_per_month ?? "");
      setPref(user.task_preference || "none");
    }
  }, [user]);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/users/me", {
        max_shifts_per_month: maxM === "" ? null : parseInt(maxM, 10),
        task_preference: pref === "none" ? "" : pref,
      });
      await refreshUser?.();
      toast.success("Voorkeuren opgeslagen");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-6 max-w-lg" data-testid="my-preferences-page">
      <div>
        <h1 className="font-heading text-3xl font-extrabold tracking-tight">Mijn voorkeuren</h1>
        <p className="text-muted-foreground mt-1">Deze voorkeuren helpen de planner bij het inplannen. Het blijft een hulpmiddel — geen harde regel.</p>
      </div>
      <Card className="p-5 space-y-4">
        <div className="space-y-1.5">
          <Label>Max. aantal diensten per maand</Label>
          <Input type="number" min="0" value={maxM} onChange={(e) => setMaxM(e.target.value)} placeholder="Leeg = geen voorkeur" data-testid="pref-max-month" />
        </div>
        <div className="space-y-1.5">
          <Label>Voorkeurstaak</Label>
          <Select value={pref} onValueChange={setPref}>
            <SelectTrigger data-testid="pref-task"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">Maakt niet uit</SelectItem>
              <SelectItem value="tappen">Tappen</SelectItem>
              <SelectItem value="poetsen">Poetsen</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <Button onClick={save} disabled={busy} data-testid="pref-save">{busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Opslaan</Button>
      </Card>
    </div>
  );
}
